<template>
  <div>
    <v-tooltip top>
      <v-btn slot="activator" flat icon @click.prevent="clickView()">
        <v-icon>visibility</v-icon>
      </v-btn>
      <span>Visualizar dados do cliente</span>                  
    </v-tooltip>
    <v-dialog v-model="dialogViewClient" scrollable width="500px">
      <v-card justify-center>
        <v-card-title>
          <span class="headline"><strong>Dados do Cliente</strong></span>
          <v-tooltip bottom>
            <v-btn slot="activator" icon style="right: 0; top: 0; position: absolute" fab @click="dialogViewClient = false">
              <v-icon color="black">close</v-icon>
            </v-btn>
            <span>Fechar</span>
          </v-tooltip>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap>    
            <v-flex xs12 text-xs-center>
              <v-avatar size="100px" v-ripple v-if="clientValues['auto']" class="grey lighten-3">
                <img v-if="clientValues['connection_company']['logo_path']" :src="`${basePath}uploads/companies/${clientValues['connection_company']['logo_path']}`" alt="avatar">
                <span v-else>Imagem buscada do parceiro</span>
              </v-avatar>
              <v-avatar size="100px" v-ripple v-else class="grey lighten-3">
                <img v-if="clientValues['logo_path']" :src="`${basePath}uploads/connections/${clientValues['logo_path']}`" alt="avatar">
                <span v-else>Não existe foto</span>
              </v-avatar>
            </v-flex>
            <v-flex xs12 sm2 class="my-1">
              <div class="p-label">Código</div>
              <div v-if="clientValues['identifier']" class="p-content-client break-word" style="white-space: pre-line;">{{clientValues['identifier']}}</div>
              <div v-else class="p-content-client"> </div>
            </v-flex>
            <v-flex xs12 sm10 class="my-1"> 
              <div class="p-label">Nome</div>
              <div class="p-content-client break-word" style="white-space: pre-line;">{{clientValues['connection_company'] ? clientValues['connection_company']['id_text'] : clientValues['id_text']}}</div>
            </v-flex>
            <v-flex xs12 sm6 class="my-1">   
              <div class="p-label">CPF/CNPJ</div>
              <div v-if="clientValues['connection_company']" class="p-content-client break-word" style="white-space: pre-line;">{{clientValues['connection_company']['cpfcnpj'] ? clientValues['connection_company']['cpfcnpj'] : ' '}}</div>
              <div v-else class="p-content-client break-word" style="white-space: pre-line;">{{clientValues['cpfcnpj'] ? clientValues['cpfcnpj'] : ' '}}</div>
            </v-flex>
            <v-flex xs12 sm6 class="my-1">
              <div class="p-label">RG/IE</div>
              <div v-if="clientValues['auto']" class="p-content-client break-word" style="white-space: pre-line;">{{clientValues['connection_company']['rgie'] ? clientValues['connection_company']['rgie'] : ' '}}</div>
              <div v-else class="p-content-client break-word" style="white-space: pre-line;">{{clientValues['rgie'] ? clientValues['rgie'] : ' '}}</div>
            </v-flex>
            <v-flex xs12 sm6 class="my-1">
              <div class="p-label">Endereço</div>
              <div v-if="clientValues['auto']" class="p-content-client break-word" style="white-space: pre-line;">{{clientValues['connection_company']['address'] ? clientValues['connection_company']['address'] : ' '}}</div>
              <div v-else class="p-content-client break-word">{{clientValues['address'] ? clientValues['address'] : ' '}}</div>
            </v-flex>
            <v-flex xs12 sm6 class="my-1">
              <div class="p-label">Número</div>
              <div v-if="clientValues['auto']" class="p-content-client break-word" style="white-space: pre-line;">{{clientValues['connection_company']['number'] ? clientValues['connection_company']['number'] : ' '}}</div>
              <div v-else class="p-content-client break-word">{{clientValues['number'] ? clientValues['number'] : ' '}}</div>
            </v-flex>
            <v-flex xs12 sm6 class="my-1">
              <div class="p-label">Bairro</div>
              <div v-if="clientValues['auto']" class="p-content-client break-word" style="white-space: pre-line;">{{clientValues['connection_company']['neighborhood'] ? clientValues['connection_company']['neighborhood'] : ' '}}</div>
              <div v-else class="p-content-client break-word">{{clientValues['neighborhood'] ? clientValues['neighborhood'] : ' '}}</div>
            </v-flex>
            <v-flex xs12 sm6 class="my-1">  
              <div class="p-label">Complemento</div>
              <div v-if="clientValues['auto']" class="p-content-client break-word" style="white-space: pre-line;">{{clientValues['connection_company']['complement'] ? clientValues['connection_company']['complement'] : ' '}}</div>
              <div v-else class="p-content-client break-word">{{clientValues['complement'] ? clientValues['complement'] : ' '}}</div>
            </v-flex>
            <v-flex xs12 sm6 class="my-1"> 
              <div class="p-label">Cidade</div>
              <div v-if="clientValues['auto']" class="p-content-client break-word" style="white-space: pre-line;">{{clientValues['connection_company']['city'] ? clientValues['connection_company']['city'] : ' '}}</div>
              <div v-else class="p-content-client break-word">{{clientValues['city'] ? clientValues['city'] : ' '}}</div>
            </v-flex>
            <v-flex xs12 sm6 class="my-1">
              <div class="p-label">CEP </div>
              <div v-if="clientValues['auto']" class="p-content-client break-word" style="white-space: pre-line;">{{clientValues['connection_company']['cep'] ? clientValues['connection_company']['cep'] : ' '}}</div>
              <div v-else class="p-content-client break-word">{{clientValues['cep'] ? clientValues['cep'] : ' '}}</div>
            </v-flex>
            <v-flex xs12 sm6 class="my-1">  
              <div class="p-label">Telefone</div>
              <div v-if="clientValues['auto']" class="p-content-client break-word" style="white-space: pre-line;">{{clientValues['connection_company']['phone'] ? clientValues['connection_company']['phone'] : ' '}}</div>
              <div v-else class="p-content-client break-word">{{clientValues['phone'] ? clientValues['phone'] : ' '}}</div>
            </v-flex>
            <v-flex xs12 sm6 class="my-1">
              <div class="p-label">Email</div>
              <div v-if="clientValues['auto']" class="p-content-client break-word" style="white-space: pre-line;">{{clientValues['connection_company']['email'] ? clientValues['connection_company']['email'] : ' '}}</div>
              <div v-else class="p-content-client break-word">{{clientValues['email'] ? clientValues['email'] : ' '}}</div>
            </v-flex>
            <v-flex xs12 class="my-1">
              <div class="p-label">Observação</div>
              <div v-html="clientValues.note ? clientValues.note : ' '" class="p-content-client break-word"></div>
            </v-flex>
            <v-flex xs12 md6 v-for="(customField, index) in clientValues['customFields']" :key="index">
                <div class="p-label">{{customField['title']}}</div>
                <div class="p-content-client break-word">{{getCustomFieldValue(customField)}}</div>
              </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn round color="primary" dark @click="dialogViewClient = false">Sair</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  /* eslint-disable no-useless-escape */
  import moment from 'moment'
  
  export default {
    name: 'PViewClient',
    props: {
      client_id: {
        type: Number,
        default: 0
      },
      task_id: {
        type: Number,
        default: 0
      }
    },
    data: function () {
      return {
        dialogViewClient: false,
        basePath: process.env.API,
        clientValues: {}
      }
    },
    methods: {
      clickView () {
        this.$store.commit('loader/change_dialog', true)
        // caso venha de uma tarefa compartilhada, usa um link proprio para buscar os dados sem o login. Caso contrario, usa o link de connections normal
        let link = `api/connections/${this.client_id}`
        this.$http.get(link).then(res => {
          this.clientValues = res.body
          // regex para pesquisar os links
          if (this.clientValues.note) {
            var regex = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi
            this.clientValues.note = this.clientValues.note.replace(regex, (url) => {
              // Substitui todas a palavras de link por link e verifica se precisa adicionar o https antes, pois se não for com o http n entra no link certo
              return `<a target="_blank" href="${!url.includes('http') ? 'https://' : ''}${url}">${url}</a>`
            })
          }
          this.dialogViewClient = true
          this.$store.commit('loader/change_dialog', false)
        }, err => {
          console.log(err)
          this.$store.commit('loader/change_dialog', false)
          this.$store.commit('snackbar/change_values', {
            text: 'Não foi possível carregar os dados do cliente, reporte o erro.',
            color: 'error',
            dialog: true
          })
        })
      },
      getCustomFieldValue (customField) {
        switch (customField['type']) {
          case 'select':
            return customField['value_item'] ? customField['value_item']['id_text'] : ''
          case 'multiselect':
            return (Array.isArray(customField['value_item'])) ? customField['value_item'].map((val) => { return val['id_text'] }).toString() : ''
          case 'date':
            return customField['value'] ? moment(customField['value']).format('DD/MM/YYYY') : ''
          case 'value':
            return customField['value'] ? 'R$ ' + parseFloat(customField['value']).toLocaleString('pt-BR') : ''
          default:
            return customField['value'] ? customField['value'] : ''
        }
      }
    }
  }
</script>

<style scoped>
  .p-label {
    font-size: 9pt;
    color: #1d1d1d;
    font-weight: 600;
    padding-left: 8px;
  }
  .p-content-client {
    font-size: 12pt;
    padding-left: 8px;
    /* font-weight: 600; */
  }
</style>


// WEBPACK FOOTER //
// src/components/shared/PViewClient.vue